import React from 'react';
import { SENSITIVE_KEYS } from '../../lib/constants.js';
import { CopyButton } from './CopyButton.js';

interface JsonViewerProps {
  data: unknown;
  maxHeight?: string;
  allowCopy?: boolean;
}

function maskSensitiveData(obj: any): any {
  if (obj === null || obj === undefined) return obj;
  if (typeof obj !== 'object') return obj;

  if (Array.isArray(obj)) {
    return obj.map(maskSensitiveData);
  }

  const result: Record<string, any> = {};
  for (const [key, value] of Object.entries(obj)) {
    const isSensitive = SENSITIVE_KEYS.some((s) => key.toLowerCase().includes(s));
    if (isSensitive && typeof value === 'string') {
      result[key] = '••••••••[REDACTED]';
    } else if (typeof value === 'object' && value !== null) {
      result[key] = maskSensitiveData(value);
    } else {
      result[key] = value;
    }
  }
  return result;
}

export function JsonViewer({ data, maxHeight = '320px', allowCopy = true }: JsonViewerProps) {
  if (data === undefined || data === null) {
    return <span className="text-slate-400 italic text-xs">null</span>;
  }

  const safeData = maskSensitiveData(data);
  const jsonString = JSON.stringify(safeData, null, 2);
  const lineCount = jsonString.split('\n').length;

  return (
    <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-slate-950 text-slate-100 overflow-hidden font-mono text-xs shadow-inner flex flex-col">
      <div className="flex items-center justify-between px-3 py-2 bg-slate-900 border-b border-slate-800 text-[11px] text-slate-400 select-none">
        <div className="flex items-center gap-2">
          <span className="inline-block w-2 h-2 rounded-full bg-emerald-500" />
          <span className="font-semibold text-slate-300">JSON Metama'lumotlar</span>
          <span className="text-[10px] px-1.5 py-0.5 rounded bg-slate-800 text-slate-400">
            {lineCount} qator
          </span>
        </div>
        {allowCopy && (
          <CopyButton
            value={jsonString}
            truncate={false}
            className="bg-slate-800 hover:bg-slate-700 text-slate-200 text-xs px-2.5 py-1 rounded-md"
          />
        )}
      </div>
      <div className="p-3.5 overflow-auto select-text" style={{ maxHeight }}>
        <pre className="leading-relaxed whitespace-pre font-mono text-emerald-400/90 text-xs">
          {jsonString}
        </pre>
      </div>
    </div>
  );
}
